/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.pip = (await import('./pages/Pip')).Pip;
    Components.pcp = (await import('./pages/Pcp')).Pcp;
    Components.home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  pip: {
    name: 'Pip',
    componentName: 'Pip',
    chunk: () => import('./pages/Pip'),
    get component() {
      return ssr
        ? serverPages.pip
        : currentRouteName === 'Pip'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Pip }))
          );
    },
    path: '/:context?/p/:slug?/:slug?/:omsId/*',
    prefetch: ['browse'],
    channel: null,
  },
  pcp: {
    name: 'Pcp',
    componentName: 'Pcp',
    chunk: () => import('./pages/Pcp'),
    get component() {
      return ssr
        ? serverPages.pcp
        : currentRouteName === 'Pcp'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Pcp }))
          );
    },
    path: '/:context?/countertops/configurator/:omsId',
    channel: null,
  },
  pcpItem: {
    name: 'PcpItem',
    componentName: 'PcpItem',
    chunk: () => import('./pages/Pcp'),
    get component() {
      return ssr
        ? serverPages.pcp
        : currentRouteName === 'PcpItem'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Pcp }))
          );
    },
    path: '/:context?/countertops/configurator/:omsId/item/:itemId',
    channel: null,
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Home }))
          );
    },
    path: '/:context?/',
    channel: null,
  },
});
